import { motion } from "framer-motion";
// import Solutions from "../component/Solutions";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Career() {
  return (
    <>
      <Helmet>
        <title>Careers at Blockcryp | Join Our Blockchain & AI Team</title>
        <meta
          name="description"
          content="Explore exciting career opportunities at Blockcryp. Join our expert team in blockchain, AI, and Web3 development. Build the future of decentralized tech with us."
        />
        <meta
          name="keywords"
          content="blockchain jobs, AI development careers, Web3 developer jobs, careers at Blockcryp, blockchain developer openings, smart contract job opportunities, crypto tech jobs, decentralized tech careers, AI engineer jobs, Web3 startup careers"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <div className="space80 position-relative">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-2 order-lg-1">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold mb-4"
              >
                Grow And Lead With The Nadcab Team
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                We’re hiring experienced professionals as well as interns to
                nurture their talent, encourage bold ideas, and inspire them to
                lead innovation across modern technologies and global Web3
                ecosystems.
              </motion.p>
              <motion.button
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="button theme_btn mt-lg-4 mt-0"
                type="submit"
              >
                View Job Opportunities
              </motion.button>
            </div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="col-lg-6 order-1 order-lg-2"
            >
              <ImageWithSkeleton
                src="assets/images/career/career1.webp"
                alt=""
                className="w-100"
              />
              {/* <img
                src="assets/images/career/career1.webp"
                alt=""
                className="w-100"
              /> */}
            </motion.div>
          </div>
        </div>
      </div>
      {/* ---------- hreo section end ---------- */}
      {/* 
      <section className="career_form space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Browse our open positions to get started on{" "}
                <br className="d-none d-lg-block"></br>
                <span className="text-primary ps-2"> your dream career!</span>
              </motion.h2>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="part_form border_lg"
              >
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Full Name</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Your Full Name"
                        name="full name"
                        id="full name"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Email</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Your Email"
                        name="email"
                        id="email"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Phone </label>
                      <span className="text-danger ms-1">*</span>
                      <div className="input_group">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Phone Number"
                          name="contact"
                          id="phone"
                          pattern="[0-9]{10}"
                          required=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Age</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="age"
                        name="age"
                        id="age"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label>Address</label>
                      <span className="text-danger ms-1">*</span>
                      <textarea
                        type="Address"
                        rows="6"
                        className="form-control"
                        placeholder="Address"
                        name="Address"
                        id="Address"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>City</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="city"
                        name="city"
                        id="city"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>
                        Which option best describes your current role?{" "}
                      </label>
                      <span className="text-danger ms-1">*</span>
                      <div className="input_group">
                        <select name="" className="form-control form-select">
                          <option value="select">Select an Option </option>

                          <option value="+Student">Student</option>
                          <option value="Full Time Job">Full Time Job</option>
                          <option value="Part Time Job">Part Time Job</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label>Department</label>
                      <span className="text-danger ms-1">*</span>
                      <div>
                        <ul className="inputs-list multi-container">
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="ASB Academy"
                                onclick="onlyOne(this)"
                              />
                              <span>ASB Academy</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="Business Analyst"
                                onclick="onlyOne(this)"
                              />
                              <span>Business Analyst</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="DevOps"
                                onclick="onlyOne(this)"
                              />
                              <span>DevOps</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="Engineering"
                                onclick="onlyOne(this)"
                              />
                              <span>Engineering</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="Gaming & Metaverse"
                                onclick="onlyOne(this)"
                              />
                              <span>Gaming & Metaverse</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="Marketing"
                                onclick="onlyOne(this)"
                              />
                              <span>Marketing</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="checkbox"
                                name="project_category"
                                defaultValue="Product"
                                onclick="onlyOne(this)"
                              />
                              <span>Product</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label>Would you like to list references?</label>
                      <span className="text-danger ms-1">*</span>
                      <div>
                        <ul className="inputs-list multi-container">
                          <li>
                            <label>
                              <input
                                type="radio"
                                name="launch_15_days"
                                defaultValue="Yes"
                                required=""
                              />
                              <span>Yes</span>
                            </label>
                          </li>
                          <li>
                            <label>
                              <input
                                type="radio"
                                name="launch_15_days"
                                defaultValue="No"
                                required=""
                              />
                              <span>No</span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3">
                    <button
                      className="button theme_btn mt-4 mt-lg-0"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section> */}

      {/* ---------  Specialties start ----------- */}
      <section className="specialties space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Our
                <span className="text-primary ps-2">Specialties</span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text-center pera_txt"
              >
                We are equipped with the experience, expertise, and resources to
                deliver end-to-end <br></br> solutions to boost the growth of
                our partners and customers.
              </motion.p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="specialties_card border_lg">
                <div className="row justify-content-around align-items-center flex-wrap">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-users"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      A growing team with <br></br> 500+ employees
                    </p>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fas fa-tools"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      Matchless technical skills <br></br>and expertise
                    </p>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fas fa-cubes"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      Blockcryp is a ‘Global Industry <br></br> Leader’ in the
                      blockchain niche.
                    </p>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------  Specialties end ----------- */}

      {/* --------------- cta start  ------------- */}
      <section className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <motion.h2
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Join Our Team
                </motion.h2>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  Be part of a dynamic design team that transforms imaginative
                  concepts into vivid
                  <br className="d-none d-lg-block"></br> realities through
                  innovative strategies and powerful creative execution.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn home_btn theme_btn mt-3"
                  >
                    let's talk <i class="fa-solid fa-square-up-right ms-2"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------- cta end  ------------- */}

      {/* <Solutions /> */}
    </>
  );
}
